<template>
  <div style="background: rgba(232,232,232,0.12)">
    <about-title  :title="$t('اخبار')" page-route="/sub/glass/news/all-news"/>
    <v-container>
      <v-row>
        <v-col v-for="(newsItem,i) in news.topics" :key="i" cols="12">
          <BlockNewsItem :news-item="newsItem"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import AboutTitle from "../../../About/Components/AboutTitle";
import BlockNewsItem from "../../components/GlassNewsItem";
import {mapState} from "vuex";
export default {
  name: 'newsItem',
  components: {BlockNewsItem, AboutTitle},
  created() {
    this.$store.dispatch('lightBlocksManagement/getBlockNews',{
      page:this.page
    });
  },
  computed:{
    ...mapState({
      news:state => state.lightBlocksManagement.blockNews,
    })
  },
  data(){
    return{
      page:1
    }
  }
}
</script>
<style scoped>
.skewBox {
  margin-top: 12px;
  display: inline-block;
  padding: 12px;
  background-color: #e8ebf0;
  color: #8198c2 !important;
  transform: skew(
      -13deg, 0);
  -webkit-transform: skew(
      -13deg, 0);
  -moz-transform: skew(-13deg, 0);
  -o-transform: skew(-13deg, 0);
}

.date-box {
  border-bottom: 1px solid #dcdcdc;
  width: 100%;
  margin-bottom: 7px;
}
.card:hover{
  transition: all 0.5s cubic-bezier(0.7, 0.01, 0.3, 1);
  box-shadow: -1px 1px 16px -3px #00000038;
}
/*.card:hover>.my>.t-box{*/
/*  display: block;*/
/*  position: relative;*/
/*  box-sizing: border-box;*/
/*  background: #0846be !important;*/
/*  color: white !important;*/
/*  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);*/
/*  animation: colored ease-in 3s;*/
/*}*/

.card:hover>.my>.t-box>*{
  color: white;
  z-index: 99;
  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);
}
.card:hover>.my>.t-box>*>*{
  color: white;
  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);
}




@keyframes shake {
  25% {
    transform: rotate(calc(var(--angle) * -1));
  }

  50% {
    transform: rotate(var(--angle));
  }

  100% {
    transform: rotate(0deg);
  }
}

body {
  font: 100 1.3em sans-serif;
  display: flex;
  flex-direction: column;
  align-content: center;
  padding: 0 5rem;
}

h1 {
  font-weight: 100;
}

.display {
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 0.1em;
}

.HOVER {
  --width: 100%;
  --time: 0.7s;

  position: relative;
  display: inline-block;
  padding: 1em;

  color: white;
  background: #222;
  overflow: hidden;
}

.HOVER text {
  position: relative;
  z-index: 5;

  transition: color var(--time);
}

.HOVER:hover text {
  color: #222;
}

.card:hover>.my>.HOVER span {
  position: absolute;
  display: block;
  content: "";
  z-index: 0;
  width: 0;
  height: 0;
  border-radius: 100%;
  background: #0846be;
  transform: translate(2%, -48%);
  transition: width var(--time), padding-top var(--time);
}

.card:hover>.my>.HOVER span {
  width: calc(var(--width) * 12.25);
  padding-top: calc(var(--width) * 28.25);
}

</style>